import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadCompanyProfile, leadCompanyProfilesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const LEAD_COMPANY_PROFILE_MODULE = 'leadCompanyProfile';

const dataObjectModule = getDataObjectsModule<ILeadCompanyProfile>(leadCompanyProfilesManager);
const searchModule = getSearchModule<ILeadCompanyProfile>(leadCompanyProfilesManager);

const leadCompanyProfileModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(LEAD_COMPANY_PROFILE_MODULE, leadCompanyProfileModuleInstance);

export { LEAD_COMPANY_PROFILE_MODULE };
